import moment from 'moment';

import { defaultSearchState } from 'state/defaults';
import {
  PAST_WEEK_SEARCH_TYPE,
  PAST_MONTH_SEARCH_TYPE,
  CUSTOM_DATE_SEARCH_TYPE,
  PO_NUMBER_SEARCH_TYPE,
  SO_NUMBER_SEARCH_TYPE,
  TRACKING_NUMBER_SEARCH_TYPE,
  PROJECT_ID_SEARCH_TYPE,
  SERIAL_NUMBER_SEARCH_TYPE,
  OPEN_ORDERS_SEARCH_TYPE,
} from 'utils/constants';

// Built options to be used on search type dropdown
export const SEARCH_TYPE_OPTIONS = [
  { text: 'Past Week', id: PAST_WEEK_SEARCH_TYPE },
  { text: 'Past Month', id: PAST_MONTH_SEARCH_TYPE },
  { text: 'Custom Date Range', id: CUSTOM_DATE_SEARCH_TYPE },
  { text: 'Open Orders', id: OPEN_ORDERS_SEARCH_TYPE },
  { text: 'Purchase Order Number', id: PO_NUMBER_SEARCH_TYPE },
  { text: 'Sales Order Number', id: SO_NUMBER_SEARCH_TYPE },
  { text: 'Tracking Number', id: TRACKING_NUMBER_SEARCH_TYPE },
  { text: 'Project ID', id: PROJECT_ID_SEARCH_TYPE },
  { text: 'Serial Number', id: SERIAL_NUMBER_SEARCH_TYPE },
];

// Initial field values based on the selected search type
export const DEFAULT_FIELDS_BY_SEARCH_TYPE = {
  [PAST_WEEK_SEARCH_TYPE]: defaultSearchState,
  [PAST_MONTH_SEARCH_TYPE]: defaultSearchState,
  [OPEN_ORDERS_SEARCH_TYPE]: defaultSearchState,
  [CUSTOM_DATE_SEARCH_TYPE]: {
    ...defaultSearchState,
    orderDateStart: moment().subtract(1, 'week').format('YYYY-MM-DD'),
    orderDateEnd: moment().format('YYYY-MM-DD'),
  },
};
